import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import { LEGACY_DEVELOPMENTS, FootprintMap } from "./Home";

export default function Projects() {
  return (
    <div data-testid="projects-page" className="pt-28 sm:pt-36">
      <SEO title="Our Developments — RK Builders"
        description="Eight residential developments define the RK Builders journey — Palm Green City, Shree Shyam Vatika, Shree Radha Kunj, Golden Enclave, Aluna City, Radha Enclave, Shree Shyam Enclave and Sai Enclave." />

      <header className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-14">
        <Eyebrow>RK Builders</Eyebrow>
        <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4">
          Our <span className="italic text-[#C5A059]">Developments</span>
        </h1>
        <p className="text-base text-[#94A3B8] leading-loose mt-8 max-w-2xl">
          Eight residential developments shape the RK Builders journey so far — each one planned around
          organised infrastructure, enduring relationships and long-term value. New communities are in
          preparation across the region.
        </p>
      </header>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-8">
        <Reveal>
          <Eyebrow>Our Development Legacy</Eyebrow>
          <h2 className="font-serif font-light text-3xl sm:text-4xl text-[#FBF9F5] mt-4">
            Developments That Define Our Journey
          </h2>
        </Reveal>
        <div className="mt-14 flex flex-wrap items-center" data-testid="projects-legacy-wall">
          {LEGACY_DEVELOPMENTS.map((name, i) => (
            <div key={name} className="flex items-center">
              <Reveal delay={i * 0.05} className="group relative py-4 sm:py-6">
                <span
                  className="block font-serif font-light text-2xl sm:text-4xl lg:text-[44px] text-[#FBF9F5]/75 group-hover:text-[#C5A059] transition-colors duration-500 cursor-default leading-tight"
                  data-testid={`projects-legacy-item-${i}`}
                >
                  {name}
                </span>
                <span className="block h-5 text-[10px] uppercase tracking-[0.25em] text-[#94A3B8] opacity-0 group-hover:opacity-100 transition-opacity duration-500 mt-1">
                  An RK Builders Development
                </span>
              </Reveal>
              {i < LEGACY_DEVELOPMENTS.length - 1 && (
                <span className="mx-5 sm:mx-9 w-px h-8 sm:h-12 bg-[#C5A059]/25 shrink-0 self-center" aria-hidden="true" />
              )}
            </div>
          ))}
        </div>
        <Reveal className="mt-6">
          <p className="text-xs text-[#94A3B8]/70 leading-relaxed max-w-xl">
            Detailed project pages — specifications, plans, pricing and availability — are published as each
            development's details are officially confirmed.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20">
        <Reveal>
          <Eyebrow>Our Footprint</Eyebrow>
          <h2 className="font-serif font-light text-3xl sm:text-4xl text-[#FBF9F5] mt-4 mb-12">
            A Growing Development Footprint
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <FootprintMap />
          <p className="font-serif italic text-lg sm:text-xl text-[#94A3B8] text-center mt-10">
            Rooted in the region. Growing with every new community.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-28 text-center">
        <Reveal>
          <p className="font-serif font-light text-2xl sm:text-4xl text-[#FBF9F5] leading-snug max-w-2xl mx-auto">
            Considering a plot or villa with RK Builders?
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
            <Link to="/site-visit" data-testid="projects-site-visit-btn"
              className="text-[11px] uppercase tracking-[0.22em] font-semibold bg-[#C5A059] text-[#060A12] px-10 py-4 hover:bg-[#d6b678] transition-colors duration-300">
              Book a Site Visit
            </Link>
            <Link to="/contact?type=property" data-testid="projects-enquiry-btn"
              className="group inline-flex items-center gap-4 text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FBF9F5]">
              <span className="group-hover:text-[#C5A059] transition-colors duration-500">Enquire About a Property</span>
              <span className="w-11 h-11 rounded-full border border-[#C5A059]/50 flex items-center justify-center transition-all duration-500 group-hover:bg-[#C5A059]">
                <ArrowRight size={15} className="text-[#C5A059] transition-all duration-500 group-hover:text-[#060A12] group-hover:translate-x-0.5" />
              </span>
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
